<template>
  <div class="content">
    <common-header
      v-if="isApplicant"
      :data="['home', 'jobOpenings', 'singleJob']"
      :componentName="jobData.job_name"
      type="applicant"
    />
    <div :class="{ container: isApplicant }">
      <h1>{{ jobData.job_name }}</h1>
      <div class="applybtn" v-if="!canApplyJobs[jobData.id]">
        <router-link
          :to="{
            name: isApplicant ? 'jobApplicationForm' : 'applicationForm',
            query: { jobId },
          }"
          tag="a"
          class="btn btn-cp ml-2"
          ><i aria-hidden="true" class="fa fa-thumbs-o-up"></i>Apply
          Now</router-link
        >
      </div>
      <div class="wrapper-white-bg">
        <safe-content
          v-if="jobData.job_description"
          :content="jobData.job_description"
          className="description"
          tag="div"
        >
        </safe-content>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @memberof module:Home
 * @namespace components.job_description
 */
import { mapGetters } from "vuex";

export default {
  /**
   * @memberof module:Home.components.job_description
   * @returns {Object} data object
   * @description data - returns data for current vue component
   */
  props: {
    isApplicant: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      jobId: this.$route.params.jobId,
      jobData: {},
    };
  },
  created() {
    this.$store.dispatch("$_home/fetchCategoriesWithJobs");
  },
  methods: {
    fetchJob() {
      this.jobData = this.currentOpenings.jobs.find(
        (item) => item.slug === this.jobId
      );
    },
  },
  computed: {
    ...mapGetters({
      currentOpenings: "$_home/categoriesWithJobs",
    }),
    canApplyJobs() {
      return this.isApplicant
        ? this.$store.getters["$_applicant_master/getCanApplyJobs"]
        : {};
    },
  },
  watch: {
    /**
     * @memberof module:Home.components.job_description
     * @param {Object} value new value
     * @description watch - changes values of Current Opening when data is udpated from server
     */
    currentOpenings(value) {
      if (value.jobs.length) {
        this.fetchJob();
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  destroyed() {
    $("#navmenu").removeClass("custom-header");
  },
};
</script>
<style scoped>
.description {
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
}
.applybtn {
  margin-left: 20px;
  margin-top: 30px;
}
</style>
